import { Run, RunState } from "types/generated";
import { Spacing } from "types/Spacing";

export const COLUMN_ORDER_APPROVAL = "2rem 14rem minmax(30rem, 2fr) minmax(8rem, 1fr) 34rem 8rem";
export const COLUMN_ORDER_USER = "14rem minmax(30rem, 2fr) minmax(8rem, 1fr) 34rem 1fr";
export const COLUMN_GAP: Spacing = "large";

enum STACK_RUNS_SELECT_ALL_OPTIONS {
  ALL = "ALL",
  QUEUED = "QUEUED",
}

type StackRunsSelectAllOption = {
  id: string;
  title: string;
  filter?: (run: Run) => boolean;
};

export const SELECT_ALL_OPTIONS: StackRunsSelectAllOption[] = [
  {
    id: STACK_RUNS_SELECT_ALL_OPTIONS.ALL,
    title: "Select all runs (in all visible commits)",
  },
  {
    id: STACK_RUNS_SELECT_ALL_OPTIONS.QUEUED,
    title: "Select queued runs (in all visible commits)",
    filter: (run) => run.state === RunState.Queued,
  },
];
